var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReportsSolid = function SvgReportsSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 1.5H13.872C13.5631 0.626106 12.7297 0 11.75 0H8.25C7.27034 0 6.43691 0.626106 6.12803 1.5H5.5C3.29086 1.5 1.5 3.29086 1.5 5.5V16C1.5 18.2091 3.29086 20 5.5 20H14.5C16.7091 20 18.5 18.2091 18.5 16V5.5C18.5 3.29086 16.7091 1.5 14.5 1.5ZM13.25 9.5C13.25 9.91421 12.9142 10.25 12.5 10.25H7.5C7.08579 10.25 6.75 9.91421 6.75 9.5C6.75 9.08579 7.08579 8.75 7.5 8.75H12.5C12.9142 8.75 13.25 9.08579 13.25 9.5ZM12.5 14.25C12.9142 14.25 13.25 13.9142 13.25 13.5C13.25 13.0858 12.9142 12.75 12.5 12.75H7.5C7.08579 12.75 6.75 13.0858 6.75 13.5C6.75 13.9142 7.08579 14.25 7.5 14.25H12.5ZM8.25 1.5C7.83579 1.5 7.5 1.83579 7.5 2.25C7.5 2.66421 7.83579 3 8.25 3H11.75C12.1642 3 12.5 2.66421 12.5 2.25C12.5 1.83579 12.1642 1.5 11.75 1.5H8.25Z",
    fill: "currentColor"
  })));
};
export default SvgReportsSolid;